/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthenticateRouteImport } from './routes/authenticate'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PreferencesRouteImport } from './routes/preferences'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as OauthAuthorizeRouteImport } from './routes/oauth/authorize'
import { Route as WhatsNewIndexRouteImport } from './routes/whats-new/index'
import { Route as AppAccountIndexRouteImport } from './routes/_app/account/index'
import { Route as AppCadmorphIndexRouteImport } from './routes/_app/cadmorph/index'
import { Route as AppCadmorphUuidRouteImport } from './routes/_app/cadmorph/$uuid'
import { Route as AppCheckoutIndexRouteImport } from './routes/_app/checkout/index'
import { Route as AppDebugIndexRouteImport } from './routes/_app/debug/index'
import { Route as AppDiagnosisIndexRouteImport } from './routes/_app/diagnosis/index'
import { Route as AppDiagnosisUuidRouteImport } from './routes/_app/diagnosis/$uuid'
import { Route as AppEvaltoolIndexRouteImport } from './routes/_app/evaltool/index'
import { Route as AppEvaltoolStudyIdRouteImport } from './routes/_app/evaltool/$studyId'
import { Route as AppMeshgenIndexRouteImport } from './routes/_app/meshgen/index'
import { Route as AppMeshgenUuidRouteImport } from './routes/_app/meshgen/$uuid'
import { Route as AppSimopsIndexRouteImport } from './routes/_app/simops/index'
import { Route as AppSimopsStudyIdRouteImport } from './routes/_app/simops/$studyId'
import { Route as AppSimopsNewRouteImport } from './routes/_app/simops/new'
import { Route as ShareGeometryUuidRouteImport } from './routes/share/geometry/$uuid'
import { Route as ShareStudyStudyIdRouteImport } from './routes/share/study/$studyId'
import { Route as AppDebugCacheIndexRouteImport } from './routes/_app/debug/cache/index'
import { Route as AppDebugThumbnailIndexRouteImport } from './routes/_app/debug/thumbnail/index'
import { Route as AppDebugViewerIndexRouteImport } from './routes/_app/debug/viewer/index'
import { Route as AppEvaltoolStudyIdIndexRouteImport } from './routes/_app/evaltool/$studyId/index'
import { Route as AppEvaltoolStudyIdResultsRouteImport } from './routes/_app/evaltool/$studyId/results'
import { Route as AppSimopsStudyIdIndexRouteImport } from './routes/_app/simops/$studyId/index'
import { Route as AppSimopsStudyIdDiagnoseRouteImport } from './routes/_app/simops/$studyId/diagnose'
import { Route as AppSimopsStudyIdMeshRouteImport } from './routes/_app/simops/$studyId/mesh'
import { Route as AppSimopsStudyIdResultsRouteImport } from './routes/_app/simops/$studyId/results'
import { Route as AppSimopsStudyIdSetupRouteImport } from './routes/_app/simops/$studyId/setup'
import { Route as AppSimopsStudyIdSimulateRouteImport } from './routes/_app/simops/$studyId/simulate'
import { Route as AppEvaltoolStudyIdResultsIndexRouteImport } from './routes/_app/evaltool/$studyId/results/index'
import { Route as AppEvaltoolStudyIdResultsCompareRouteImport } from './routes/_app/evaltool/$studyId/results/compare'
import { Route as AppEvaltoolStudyIdResultsEvidenceRouteImport } from './routes/_app/evaltool/$studyId/results/evidence'
import { Route as AppEvaltoolStudyIdResultsOverviewRouteImport } from './routes/_app/evaltool/$studyId/results/overview'
import { Route as AppEvaltoolStudyIdResultsPointsRouteImport } from './routes/_app/evaltool/$studyId/results/points'
import { Route as AppEvaltoolStudyIdResultsTradeoffsRouteImport } from './routes/_app/evaltool/$studyId/results/tradeoffs'
import { Route as AppSimopsStudyIdResultsIndexRouteImport } from './routes/_app/simops/$studyId/results/index'
import { Route as AppSimopsStudyIdResultsCompareRouteImport } from './routes/_app/simops/$studyId/results/compare'
import { Route as AppSimopsStudyIdResultsEvidenceRouteImport } from './routes/_app/simops/$studyId/results/evidence'
import { Route as AppSimopsStudyIdResultsOverviewRouteImport } from './routes/_app/simops/$studyId/results/overview'
import { Route as AppSimopsStudyIdResultsPointsRouteImport } from './routes/_app/simops/$studyId/results/points'
import { Route as AppSimopsStudyIdResultsTradeoffsRouteImport } from './routes/_app/simops/$studyId/results/tradeoffs'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticateRoute = AuthenticateRouteImport.update({
  id: '/authenticate',
  path: '/authenticate',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PreferencesRoute = PreferencesRouteImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const OauthAuthorizeRoute = OauthAuthorizeRouteImport.update({
  id: '/oauth/authorize',
  path: '/oauth/authorize',
  getParentRoute: () => rootRouteImport,
} as any)
const WhatsNewIndexRoute = WhatsNewIndexRouteImport.update({
  id: '/whats-new/',
  path: '/whats-new/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountIndexRoute = AppAccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => AppRoute,
} as any)
const AppCadmorphIndexRoute = AppCadmorphIndexRouteImport.update({
  id: '/cadmorph/',
  path: '/cadmorph/',
  getParentRoute: () => AppRoute,
} as any)
const AppCadmorphUuidRoute = AppCadmorphUuidRouteImport.update({
  id: '/cadmorph/$uuid',
  path: '/cadmorph/$uuid',
  getParentRoute: () => AppRoute,
} as any)
const AppCheckoutIndexRoute = AppCheckoutIndexRouteImport.update({
  id: '/checkout/',
  path: '/checkout/',
  getParentRoute: () => AppRoute,
} as any)
const AppDebugIndexRoute = AppDebugIndexRouteImport.update({
  id: '/debug/',
  path: '/debug/',
  getParentRoute: () => AppRoute,
} as any)
const AppDiagnosisIndexRoute = AppDiagnosisIndexRouteImport.update({
  id: '/diagnosis/',
  path: '/diagnosis/',
  getParentRoute: () => AppRoute,
} as any)
const AppDiagnosisUuidRoute = AppDiagnosisUuidRouteImport.update({
  id: '/diagnosis/$uuid',
  path: '/diagnosis/$uuid',
  getParentRoute: () => AppRoute,
} as any)
const AppEvaltoolIndexRoute = AppEvaltoolIndexRouteImport.update({
  id: '/evaltool/',
  path: '/evaltool/',
  getParentRoute: () => AppRoute,
} as any)
const AppEvaltoolStudyIdRoute = AppEvaltoolStudyIdRouteImport.update({
  id: '/evaltool/$studyId',
  path: '/evaltool/$studyId',
  getParentRoute: () => AppRoute,
} as any)
const AppMeshgenIndexRoute = AppMeshgenIndexRouteImport.update({
  id: '/meshgen/',
  path: '/meshgen/',
  getParentRoute: () => AppRoute,
} as any)
const AppMeshgenUuidRoute = AppMeshgenUuidRouteImport.update({
  id: '/meshgen/$uuid',
  path: '/meshgen/$uuid',
  getParentRoute: () => AppRoute,
} as any)
const AppSimopsIndexRoute = AppSimopsIndexRouteImport.update({
  id: '/simops/',
  path: '/simops/',
  getParentRoute: () => AppRoute,
} as any)
const AppSimopsStudyIdRoute = AppSimopsStudyIdRouteImport.update({
  id: '/simops/$studyId',
  path: '/simops/$studyId',
  getParentRoute: () => AppRoute,
} as any)
const AppSimopsNewRoute = AppSimopsNewRouteImport.update({
  id: '/simops/new',
  path: '/simops/new',
  getParentRoute: () => AppRoute,
} as any)
const ShareGeometryUuidRoute = ShareGeometryUuidRouteImport.update({
  id: '/share/geometry/$uuid',
  path: '/share/geometry/$uuid',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareStudyStudyIdRoute = ShareStudyStudyIdRouteImport.update({
  id: '/share/study/$studyId',
  path: '/share/study/$studyId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppDebugCacheIndexRoute = AppDebugCacheIndexRouteImport.update({
  id: '/debug/cache/',
  path: '/debug/cache/',
  getParentRoute: () => AppRoute,
} as any)
const AppDebugThumbnailIndexRoute = AppDebugThumbnailIndexRouteImport.update({
  id: '/debug/thumbnail/',
  path: '/debug/thumbnail/',
  getParentRoute: () => AppRoute,
} as any)
const AppDebugViewerIndexRoute = AppDebugViewerIndexRouteImport.update({
  id: '/debug/viewer/',
  path: '/debug/viewer/',
  getParentRoute: () => AppRoute,
} as any)
const AppEvaltoolStudyIdIndexRoute = AppEvaltoolStudyIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppEvaltoolStudyIdRoute,
} as any)
const AppEvaltoolStudyIdResultsRoute =
  AppEvaltoolStudyIdResultsRouteImport.update({
    id: '/results',
    path: '/results',
    getParentRoute: () => AppEvaltoolStudyIdRoute,
  } as any)
const AppSimopsStudyIdIndexRoute = AppSimopsStudyIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSimopsStudyIdRoute,
} as any)
const AppSimopsStudyIdDiagnoseRoute =
  AppSimopsStudyIdDiagnoseRouteImport.update({
    id: '/diagnose',
    path: '/diagnose',
    getParentRoute: () => AppSimopsStudyIdRoute,
  } as any)
const AppSimopsStudyIdMeshRoute = AppSimopsStudyIdMeshRouteImport.update({
  id: '/mesh',
  path: '/mesh',
  getParentRoute: () => AppSimopsStudyIdRoute,
} as any)
const AppSimopsStudyIdResultsRoute = AppSimopsStudyIdResultsRouteImport.update({
  id: '/results',
  path: '/results',
  getParentRoute: () => AppSimopsStudyIdRoute,
} as any)
const AppSimopsStudyIdSetupRoute = AppSimopsStudyIdSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AppSimopsStudyIdRoute,
} as any)
const AppSimopsStudyIdSimulateRoute =
  AppSimopsStudyIdSimulateRouteImport.update({
    id: '/simulate',
    path: '/simulate',
    getParentRoute: () => AppSimopsStudyIdRoute,
  } as any)
const AppEvaltoolStudyIdResultsIndexRoute =
  AppEvaltoolStudyIdResultsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppEvaltoolStudyIdResultsRoute,
  } as any)
const AppEvaltoolStudyIdResultsCompareRoute =
  AppEvaltoolStudyIdResultsCompareRouteImport.update({
    id: '/compare',
    path: '/compare',
    getParentRoute: () => AppEvaltoolStudyIdResultsRoute,
  } as any)
const AppEvaltoolStudyIdResultsEvidenceRoute =
  AppEvaltoolStudyIdResultsEvidenceRouteImport.update({
    id: '/evidence',
    path: '/evidence',
    getParentRoute: () => AppEvaltoolStudyIdResultsRoute,
  } as any)
const AppEvaltoolStudyIdResultsOverviewRoute =
  AppEvaltoolStudyIdResultsOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AppEvaltoolStudyIdResultsRoute,
  } as any)
const AppEvaltoolStudyIdResultsPointsRoute =
  AppEvaltoolStudyIdResultsPointsRouteImport.update({
    id: '/points',
    path: '/points',
    getParentRoute: () => AppEvaltoolStudyIdResultsRoute,
  } as any)
const AppEvaltoolStudyIdResultsTradeoffsRoute =
  AppEvaltoolStudyIdResultsTradeoffsRouteImport.update({
    id: '/tradeoffs',
    path: '/tradeoffs',
    getParentRoute: () => AppEvaltoolStudyIdResultsRoute,
  } as any)
const AppSimopsStudyIdResultsIndexRoute =
  AppSimopsStudyIdResultsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSimopsStudyIdResultsRoute,
  } as any)
const AppSimopsStudyIdResultsCompareRoute =
  AppSimopsStudyIdResultsCompareRouteImport.update({
    id: '/compare',
    path: '/compare',
    getParentRoute: () => AppSimopsStudyIdResultsRoute,
  } as any)
const AppSimopsStudyIdResultsEvidenceRoute =
  AppSimopsStudyIdResultsEvidenceRouteImport.update({
    id: '/evidence',
    path: '/evidence',
    getParentRoute: () => AppSimopsStudyIdResultsRoute,
  } as any)
const AppSimopsStudyIdResultsOverviewRoute =
  AppSimopsStudyIdResultsOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AppSimopsStudyIdResultsRoute,
  } as any)
const AppSimopsStudyIdResultsPointsRoute =
  AppSimopsStudyIdResultsPointsRouteImport.update({
    id: '/points',
    path: '/points',
    getParentRoute: () => AppSimopsStudyIdResultsRoute,
  } as any)
const AppSimopsStudyIdResultsTradeoffsRoute =
  AppSimopsStudyIdResultsTradeoffsRouteImport.update({
    id: '/tradeoffs',
    path: '/tradeoffs',
    getParentRoute: () => AppSimopsStudyIdResultsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/authenticate': typeof AuthenticateRoute
  '/login': typeof LoginRoute
  '/preferences': typeof PreferencesRoute
  '/reset-password': typeof ResetPasswordRoute
  '/oauth/authorize': typeof OauthAuthorizeRoute
  '/whats-new/': typeof WhatsNewIndexRoute
  '/cadmorph/$uuid': typeof AppCadmorphUuidRoute
  '/diagnosis/$uuid': typeof AppDiagnosisUuidRoute
  '/evaltool/$studyId': typeof AppEvaltoolStudyIdRouteWithChildren
  '/meshgen/$uuid': typeof AppMeshgenUuidRoute
  '/simops/$studyId': typeof AppSimopsStudyIdRouteWithChildren
  '/simops/new': typeof AppSimopsNewRoute
  '/share/geometry/$uuid': typeof ShareGeometryUuidRoute
  '/share/study/$studyId': typeof ShareStudyStudyIdRoute
  '/account/': typeof AppAccountIndexRoute
  '/cadmorph/': typeof AppCadmorphIndexRoute
  '/checkout/': typeof AppCheckoutIndexRoute
  '/debug/': typeof AppDebugIndexRoute
  '/diagnosis/': typeof AppDiagnosisIndexRoute
  '/evaltool/': typeof AppEvaltoolIndexRoute
  '/meshgen/': typeof AppMeshgenIndexRoute
  '/simops/': typeof AppSimopsIndexRoute
  '/evaltool/$studyId/results': typeof AppEvaltoolStudyIdResultsRouteWithChildren
  '/simops/$studyId/diagnose': typeof AppSimopsStudyIdDiagnoseRoute
  '/simops/$studyId/mesh': typeof AppSimopsStudyIdMeshRoute
  '/simops/$studyId/results': typeof AppSimopsStudyIdResultsRouteWithChildren
  '/simops/$studyId/setup': typeof AppSimopsStudyIdSetupRoute
  '/simops/$studyId/simulate': typeof AppSimopsStudyIdSimulateRoute
  '/debug/cache/': typeof AppDebugCacheIndexRoute
  '/debug/thumbnail/': typeof AppDebugThumbnailIndexRoute
  '/debug/viewer/': typeof AppDebugViewerIndexRoute
  '/evaltool/$studyId/': typeof AppEvaltoolStudyIdIndexRoute
  '/simops/$studyId/': typeof AppSimopsStudyIdIndexRoute
  '/evaltool/$studyId/results/compare': typeof AppEvaltoolStudyIdResultsCompareRoute
  '/evaltool/$studyId/results/evidence': typeof AppEvaltoolStudyIdResultsEvidenceRoute
  '/evaltool/$studyId/results/overview': typeof AppEvaltoolStudyIdResultsOverviewRoute
  '/evaltool/$studyId/results/points': typeof AppEvaltoolStudyIdResultsPointsRoute
  '/evaltool/$studyId/results/tradeoffs': typeof AppEvaltoolStudyIdResultsTradeoffsRoute
  '/simops/$studyId/results/compare': typeof AppSimopsStudyIdResultsCompareRoute
  '/simops/$studyId/results/evidence': typeof AppSimopsStudyIdResultsEvidenceRoute
  '/simops/$studyId/results/overview': typeof AppSimopsStudyIdResultsOverviewRoute
  '/simops/$studyId/results/points': typeof AppSimopsStudyIdResultsPointsRoute
  '/simops/$studyId/results/tradeoffs': typeof AppSimopsStudyIdResultsTradeoffsRoute
  '/evaltool/$studyId/results/': typeof AppEvaltoolStudyIdResultsIndexRoute
  '/simops/$studyId/results/': typeof AppSimopsStudyIdResultsIndexRoute
}
export interface FileRoutesByTo {
  '/authenticate': typeof AuthenticateRoute
  '/login': typeof LoginRoute
  '/preferences': typeof PreferencesRoute
  '/reset-password': typeof ResetPasswordRoute
  '/oauth/authorize': typeof OauthAuthorizeRoute
  '/': typeof AppIndexRoute
  '/whats-new': typeof WhatsNewIndexRoute
  '/cadmorph/$uuid': typeof AppCadmorphUuidRoute
  '/diagnosis/$uuid': typeof AppDiagnosisUuidRoute
  '/meshgen/$uuid': typeof AppMeshgenUuidRoute
  '/simops/new': typeof AppSimopsNewRoute
  '/share/geometry/$uuid': typeof ShareGeometryUuidRoute
  '/share/study/$studyId': typeof ShareStudyStudyIdRoute
  '/account': typeof AppAccountIndexRoute
  '/cadmorph': typeof AppCadmorphIndexRoute
  '/checkout': typeof AppCheckoutIndexRoute
  '/debug': typeof AppDebugIndexRoute
  '/diagnosis': typeof AppDiagnosisIndexRoute
  '/evaltool': typeof AppEvaltoolIndexRoute
  '/meshgen': typeof AppMeshgenIndexRoute
  '/simops': typeof AppSimopsIndexRoute
  '/simops/$studyId/diagnose': typeof AppSimopsStudyIdDiagnoseRoute
  '/simops/$studyId/mesh': typeof AppSimopsStudyIdMeshRoute
  '/simops/$studyId/setup': typeof AppSimopsStudyIdSetupRoute
  '/simops/$studyId/simulate': typeof AppSimopsStudyIdSimulateRoute
  '/debug/cache': typeof AppDebugCacheIndexRoute
  '/debug/thumbnail': typeof AppDebugThumbnailIndexRoute
  '/debug/viewer': typeof AppDebugViewerIndexRoute
  '/evaltool/$studyId': typeof AppEvaltoolStudyIdIndexRoute
  '/simops/$studyId': typeof AppSimopsStudyIdIndexRoute
  '/evaltool/$studyId/results/compare': typeof AppEvaltoolStudyIdResultsCompareRoute
  '/evaltool/$studyId/results/evidence': typeof AppEvaltoolStudyIdResultsEvidenceRoute
  '/evaltool/$studyId/results/overview': typeof AppEvaltoolStudyIdResultsOverviewRoute
  '/evaltool/$studyId/results/points': typeof AppEvaltoolStudyIdResultsPointsRoute
  '/evaltool/$studyId/results/tradeoffs': typeof AppEvaltoolStudyIdResultsTradeoffsRoute
  '/simops/$studyId/results/compare': typeof AppSimopsStudyIdResultsCompareRoute
  '/simops/$studyId/results/evidence': typeof AppSimopsStudyIdResultsEvidenceRoute
  '/simops/$studyId/results/overview': typeof AppSimopsStudyIdResultsOverviewRoute
  '/simops/$studyId/results/points': typeof AppSimopsStudyIdResultsPointsRoute
  '/simops/$studyId/results/tradeoffs': typeof AppSimopsStudyIdResultsTradeoffsRoute
  '/evaltool/$studyId/results': typeof AppEvaltoolStudyIdResultsIndexRoute
  '/simops/$studyId/results': typeof AppSimopsStudyIdResultsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/authenticate': typeof AuthenticateRoute
  '/login': typeof LoginRoute
  '/preferences': typeof PreferencesRoute
  '/reset-password': typeof ResetPasswordRoute
  '/oauth/authorize': typeof OauthAuthorizeRoute
  '/_app/': typeof AppIndexRoute
  '/whats-new/': typeof WhatsNewIndexRoute
  '/_app/cadmorph/$uuid': typeof AppCadmorphUuidRoute
  '/_app/diagnosis/$uuid': typeof AppDiagnosisUuidRoute
  '/_app/evaltool/$studyId': typeof AppEvaltoolStudyIdRouteWithChildren
  '/_app/meshgen/$uuid': typeof AppMeshgenUuidRoute
  '/_app/simops/$studyId': typeof AppSimopsStudyIdRouteWithChildren
  '/_app/simops/new': typeof AppSimopsNewRoute
  '/share/geometry/$uuid': typeof ShareGeometryUuidRoute
  '/share/study/$studyId': typeof ShareStudyStudyIdRoute
  '/_app/account/': typeof AppAccountIndexRoute
  '/_app/cadmorph/': typeof AppCadmorphIndexRoute
  '/_app/checkout/': typeof AppCheckoutIndexRoute
  '/_app/debug/': typeof AppDebugIndexRoute
  '/_app/diagnosis/': typeof AppDiagnosisIndexRoute
  '/_app/evaltool/': typeof AppEvaltoolIndexRoute
  '/_app/meshgen/': typeof AppMeshgenIndexRoute
  '/_app/simops/': typeof AppSimopsIndexRoute
  '/_app/evaltool/$studyId/results': typeof AppEvaltoolStudyIdResultsRouteWithChildren
  '/_app/simops/$studyId/diagnose': typeof AppSimopsStudyIdDiagnoseRoute
  '/_app/simops/$studyId/mesh': typeof AppSimopsStudyIdMeshRoute
  '/_app/simops/$studyId/results': typeof AppSimopsStudyIdResultsRouteWithChildren
  '/_app/simops/$studyId/setup': typeof AppSimopsStudyIdSetupRoute
  '/_app/simops/$studyId/simulate': typeof AppSimopsStudyIdSimulateRoute
  '/_app/debug/cache/': typeof AppDebugCacheIndexRoute
  '/_app/debug/thumbnail/': typeof AppDebugThumbnailIndexRoute
  '/_app/debug/viewer/': typeof AppDebugViewerIndexRoute
  '/_app/evaltool/$studyId/': typeof AppEvaltoolStudyIdIndexRoute
  '/_app/simops/$studyId/': typeof AppSimopsStudyIdIndexRoute
  '/_app/evaltool/$studyId/results/compare': typeof AppEvaltoolStudyIdResultsCompareRoute
  '/_app/evaltool/$studyId/results/evidence': typeof AppEvaltoolStudyIdResultsEvidenceRoute
  '/_app/evaltool/$studyId/results/overview': typeof AppEvaltoolStudyIdResultsOverviewRoute
  '/_app/evaltool/$studyId/results/points': typeof AppEvaltoolStudyIdResultsPointsRoute
  '/_app/evaltool/$studyId/results/tradeoffs': typeof AppEvaltoolStudyIdResultsTradeoffsRoute
  '/_app/simops/$studyId/results/compare': typeof AppSimopsStudyIdResultsCompareRoute
  '/_app/simops/$studyId/results/evidence': typeof AppSimopsStudyIdResultsEvidenceRoute
  '/_app/simops/$studyId/results/overview': typeof AppSimopsStudyIdResultsOverviewRoute
  '/_app/simops/$studyId/results/points': typeof AppSimopsStudyIdResultsPointsRoute
  '/_app/simops/$studyId/results/tradeoffs': typeof AppSimopsStudyIdResultsTradeoffsRoute
  '/_app/evaltool/$studyId/results/': typeof AppEvaltoolStudyIdResultsIndexRoute
  '/_app/simops/$studyId/results/': typeof AppSimopsStudyIdResultsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/authenticate'
    | '/login'
    | '/preferences'
    | '/reset-password'
    | '/oauth/authorize'
    | '/whats-new/'
    | '/cadmorph/$uuid'
    | '/diagnosis/$uuid'
    | '/evaltool/$studyId'
    | '/meshgen/$uuid'
    | '/simops/$studyId'
    | '/simops/new'
    | '/share/geometry/$uuid'
    | '/share/study/$studyId'
    | '/account/'
    | '/cadmorph/'
    | '/checkout/'
    | '/debug/'
    | '/diagnosis/'
    | '/evaltool/'
    | '/meshgen/'
    | '/simops/'
    | '/evaltool/$studyId/results'
    | '/simops/$studyId/diagnose'
    | '/simops/$studyId/mesh'
    | '/simops/$studyId/results'
    | '/simops/$studyId/setup'
    | '/simops/$studyId/simulate'
    | '/debug/cache/'
    | '/debug/thumbnail/'
    | '/debug/viewer/'
    | '/evaltool/$studyId/'
    | '/simops/$studyId/'
    | '/evaltool/$studyId/results/compare'
    | '/evaltool/$studyId/results/evidence'
    | '/evaltool/$studyId/results/overview'
    | '/evaltool/$studyId/results/points'
    | '/evaltool/$studyId/results/tradeoffs'
    | '/simops/$studyId/results/compare'
    | '/simops/$studyId/results/evidence'
    | '/simops/$studyId/results/overview'
    | '/simops/$studyId/results/points'
    | '/simops/$studyId/results/tradeoffs'
    | '/evaltool/$studyId/results/'
    | '/simops/$studyId/results/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/authenticate'
    | '/login'
    | '/preferences'
    | '/reset-password'
    | '/oauth/authorize'
    | '/'
    | '/whats-new'
    | '/cadmorph/$uuid'
    | '/diagnosis/$uuid'
    | '/meshgen/$uuid'
    | '/simops/new'
    | '/share/geometry/$uuid'
    | '/share/study/$studyId'
    | '/account'
    | '/cadmorph'
    | '/checkout'
    | '/debug'
    | '/diagnosis'
    | '/evaltool'
    | '/meshgen'
    | '/simops'
    | '/simops/$studyId/diagnose'
    | '/simops/$studyId/mesh'
    | '/simops/$studyId/setup'
    | '/simops/$studyId/simulate'
    | '/debug/cache'
    | '/debug/thumbnail'
    | '/debug/viewer'
    | '/evaltool/$studyId'
    | '/simops/$studyId'
    | '/evaltool/$studyId/results/compare'
    | '/evaltool/$studyId/results/evidence'
    | '/evaltool/$studyId/results/overview'
    | '/evaltool/$studyId/results/points'
    | '/evaltool/$studyId/results/tradeoffs'
    | '/simops/$studyId/results/compare'
    | '/simops/$studyId/results/evidence'
    | '/simops/$studyId/results/overview'
    | '/simops/$studyId/results/points'
    | '/simops/$studyId/results/tradeoffs'
    | '/evaltool/$studyId/results'
    | '/simops/$studyId/results'
  id:
    | '__root__'
    | '/_app'
    | '/authenticate'
    | '/login'
    | '/preferences'
    | '/reset-password'
    | '/oauth/authorize'
    | '/_app/'
    | '/whats-new/'
    | '/_app/cadmorph/$uuid'
    | '/_app/diagnosis/$uuid'
    | '/_app/evaltool/$studyId'
    | '/_app/meshgen/$uuid'
    | '/_app/simops/$studyId'
    | '/_app/simops/new'
    | '/share/geometry/$uuid'
    | '/share/study/$studyId'
    | '/_app/account/'
    | '/_app/cadmorph/'
    | '/_app/checkout/'
    | '/_app/debug/'
    | '/_app/diagnosis/'
    | '/_app/evaltool/'
    | '/_app/meshgen/'
    | '/_app/simops/'
    | '/_app/evaltool/$studyId/results'
    | '/_app/simops/$studyId/diagnose'
    | '/_app/simops/$studyId/mesh'
    | '/_app/simops/$studyId/results'
    | '/_app/simops/$studyId/setup'
    | '/_app/simops/$studyId/simulate'
    | '/_app/debug/cache/'
    | '/_app/debug/thumbnail/'
    | '/_app/debug/viewer/'
    | '/_app/evaltool/$studyId/'
    | '/_app/simops/$studyId/'
    | '/_app/evaltool/$studyId/results/compare'
    | '/_app/evaltool/$studyId/results/evidence'
    | '/_app/evaltool/$studyId/results/overview'
    | '/_app/evaltool/$studyId/results/points'
    | '/_app/evaltool/$studyId/results/tradeoffs'
    | '/_app/simops/$studyId/results/compare'
    | '/_app/simops/$studyId/results/evidence'
    | '/_app/simops/$studyId/results/overview'
    | '/_app/simops/$studyId/results/points'
    | '/_app/simops/$studyId/results/tradeoffs'
    | '/_app/evaltool/$studyId/results/'
    | '/_app/simops/$studyId/results/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthenticateRoute: typeof AuthenticateRoute
  LoginRoute: typeof LoginRoute
  PreferencesRoute: typeof PreferencesRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  OauthAuthorizeRoute: typeof OauthAuthorizeRoute
  WhatsNewIndexRoute: typeof WhatsNewIndexRoute
  ShareGeometryUuidRoute: typeof ShareGeometryUuidRoute
  ShareStudyStudyIdRoute: typeof ShareStudyStudyIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authenticate': {
      id: '/authenticate'
      path: '/authenticate'
      fullPath: '/authenticate'
      preLoaderRoute: typeof AuthenticateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preferences': {
      id: '/preferences'
      path: '/preferences'
      fullPath: '/preferences'
      preLoaderRoute: typeof PreferencesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/oauth/authorize': {
      id: '/oauth/authorize'
      path: '/oauth/authorize'
      fullPath: '/oauth/authorize'
      preLoaderRoute: typeof OauthAuthorizeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/whats-new/': {
      id: '/whats-new/'
      path: '/whats-new'
      fullPath: '/whats-new/'
      preLoaderRoute: typeof WhatsNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/account/': {
      id: '/_app/account/'
      path: '/account'
      fullPath: '/account/'
      preLoaderRoute: typeof AppAccountIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadmorph/': {
      id: '/_app/cadmorph/'
      path: '/cadmorph'
      fullPath: '/cadmorph/'
      preLoaderRoute: typeof AppCadmorphIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadmorph/$uuid': {
      id: '/_app/cadmorph/$uuid'
      path: '/cadmorph/$uuid'
      fullPath: '/cadmorph/$uuid'
      preLoaderRoute: typeof AppCadmorphUuidRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/checkout/': {
      id: '/_app/checkout/'
      path: '/checkout'
      fullPath: '/checkout/'
      preLoaderRoute: typeof AppCheckoutIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/debug/': {
      id: '/_app/debug/'
      path: '/debug'
      fullPath: '/debug/'
      preLoaderRoute: typeof AppDebugIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/diagnosis/': {
      id: '/_app/diagnosis/'
      path: '/diagnosis'
      fullPath: '/diagnosis/'
      preLoaderRoute: typeof AppDiagnosisIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/diagnosis/$uuid': {
      id: '/_app/diagnosis/$uuid'
      path: '/diagnosis/$uuid'
      fullPath: '/diagnosis/$uuid'
      preLoaderRoute: typeof AppDiagnosisUuidRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/evaltool/': {
      id: '/_app/evaltool/'
      path: '/evaltool'
      fullPath: '/evaltool/'
      preLoaderRoute: typeof AppEvaltoolIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/evaltool/$studyId': {
      id: '/_app/evaltool/$studyId'
      path: '/evaltool/$studyId'
      fullPath: '/evaltool/$studyId'
      preLoaderRoute: typeof AppEvaltoolStudyIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meshgen/': {
      id: '/_app/meshgen/'
      path: '/meshgen'
      fullPath: '/meshgen/'
      preLoaderRoute: typeof AppMeshgenIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meshgen/$uuid': {
      id: '/_app/meshgen/$uuid'
      path: '/meshgen/$uuid'
      fullPath: '/meshgen/$uuid'
      preLoaderRoute: typeof AppMeshgenUuidRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/simops/': {
      id: '/_app/simops/'
      path: '/simops'
      fullPath: '/simops/'
      preLoaderRoute: typeof AppSimopsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/simops/$studyId': {
      id: '/_app/simops/$studyId'
      path: '/simops/$studyId'
      fullPath: '/simops/$studyId'
      preLoaderRoute: typeof AppSimopsStudyIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/simops/new': {
      id: '/_app/simops/new'
      path: '/simops/new'
      fullPath: '/simops/new'
      preLoaderRoute: typeof AppSimopsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/share/geometry/$uuid': {
      id: '/share/geometry/$uuid'
      path: '/share/geometry/$uuid'
      fullPath: '/share/geometry/$uuid'
      preLoaderRoute: typeof ShareGeometryUuidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share/study/$studyId': {
      id: '/share/study/$studyId'
      path: '/share/study/$studyId'
      fullPath: '/share/study/$studyId'
      preLoaderRoute: typeof ShareStudyStudyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/debug/cache/': {
      id: '/_app/debug/cache/'
      path: '/debug/cache'
      fullPath: '/debug/cache/'
      preLoaderRoute: typeof AppDebugCacheIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/debug/thumbnail/': {
      id: '/_app/debug/thumbnail/'
      path: '/debug/thumbnail'
      fullPath: '/debug/thumbnail/'
      preLoaderRoute: typeof AppDebugThumbnailIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/debug/viewer/': {
      id: '/_app/debug/viewer/'
      path: '/debug/viewer'
      fullPath: '/debug/viewer/'
      preLoaderRoute: typeof AppDebugViewerIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/evaltool/$studyId/': {
      id: '/_app/evaltool/$studyId/'
      path: '/'
      fullPath: '/evaltool/$studyId/'
      preLoaderRoute: typeof AppEvaltoolStudyIdIndexRouteImport
      parentRoute: typeof AppEvaltoolStudyIdRoute
    }
    '/_app/evaltool/$studyId/results': {
      id: '/_app/evaltool/$studyId/results'
      path: '/results'
      fullPath: '/evaltool/$studyId/results'
      preLoaderRoute: typeof AppEvaltoolStudyIdResultsRouteImport
      parentRoute: typeof AppEvaltoolStudyIdRoute
    }
    '/_app/simops/$studyId/': {
      id: '/_app/simops/$studyId/'
      path: '/'
      fullPath: '/simops/$studyId/'
      preLoaderRoute: typeof AppSimopsStudyIdIndexRouteImport
      parentRoute: typeof AppSimopsStudyIdRoute
    }
    '/_app/simops/$studyId/diagnose': {
      id: '/_app/simops/$studyId/diagnose'
      path: '/diagnose'
      fullPath: '/simops/$studyId/diagnose'
      preLoaderRoute: typeof AppSimopsStudyIdDiagnoseRouteImport
      parentRoute: typeof AppSimopsStudyIdRoute
    }
    '/_app/simops/$studyId/mesh': {
      id: '/_app/simops/$studyId/mesh'
      path: '/mesh'
      fullPath: '/simops/$studyId/mesh'
      preLoaderRoute: typeof AppSimopsStudyIdMeshRouteImport
      parentRoute: typeof AppSimopsStudyIdRoute
    }
    '/_app/simops/$studyId/results': {
      id: '/_app/simops/$studyId/results'
      path: '/results'
      fullPath: '/simops/$studyId/results'
      preLoaderRoute: typeof AppSimopsStudyIdResultsRouteImport
      parentRoute: typeof AppSimopsStudyIdRoute
    }
    '/_app/simops/$studyId/setup': {
      id: '/_app/simops/$studyId/setup'
      path: '/setup'
      fullPath: '/simops/$studyId/setup'
      preLoaderRoute: typeof AppSimopsStudyIdSetupRouteImport
      parentRoute: typeof AppSimopsStudyIdRoute
    }
    '/_app/simops/$studyId/simulate': {
      id: '/_app/simops/$studyId/simulate'
      path: '/simulate'
      fullPath: '/simops/$studyId/simulate'
      preLoaderRoute: typeof AppSimopsStudyIdSimulateRouteImport
      parentRoute: typeof AppSimopsStudyIdRoute
    }
    '/_app/evaltool/$studyId/results/': {
      id: '/_app/evaltool/$studyId/results/'
      path: '/'
      fullPath: '/evaltool/$studyId/results/'
      preLoaderRoute: typeof AppEvaltoolStudyIdResultsIndexRouteImport
      parentRoute: typeof AppEvaltoolStudyIdResultsRoute
    }
    '/_app/evaltool/$studyId/results/compare': {
      id: '/_app/evaltool/$studyId/results/compare'
      path: '/compare'
      fullPath: '/evaltool/$studyId/results/compare'
      preLoaderRoute: typeof AppEvaltoolStudyIdResultsCompareRouteImport
      parentRoute: typeof AppEvaltoolStudyIdResultsRoute
    }
    '/_app/evaltool/$studyId/results/evidence': {
      id: '/_app/evaltool/$studyId/results/evidence'
      path: '/evidence'
      fullPath: '/evaltool/$studyId/results/evidence'
      preLoaderRoute: typeof AppEvaltoolStudyIdResultsEvidenceRouteImport
      parentRoute: typeof AppEvaltoolStudyIdResultsRoute
    }
    '/_app/evaltool/$studyId/results/overview': {
      id: '/_app/evaltool/$studyId/results/overview'
      path: '/overview'
      fullPath: '/evaltool/$studyId/results/overview'
      preLoaderRoute: typeof AppEvaltoolStudyIdResultsOverviewRouteImport
      parentRoute: typeof AppEvaltoolStudyIdResultsRoute
    }
    '/_app/evaltool/$studyId/results/points': {
      id: '/_app/evaltool/$studyId/results/points'
      path: '/points'
      fullPath: '/evaltool/$studyId/results/points'
      preLoaderRoute: typeof AppEvaltoolStudyIdResultsPointsRouteImport
      parentRoute: typeof AppEvaltoolStudyIdResultsRoute
    }
    '/_app/evaltool/$studyId/results/tradeoffs': {
      id: '/_app/evaltool/$studyId/results/tradeoffs'
      path: '/tradeoffs'
      fullPath: '/evaltool/$studyId/results/tradeoffs'
      preLoaderRoute: typeof AppEvaltoolStudyIdResultsTradeoffsRouteImport
      parentRoute: typeof AppEvaltoolStudyIdResultsRoute
    }
    '/_app/simops/$studyId/results/': {
      id: '/_app/simops/$studyId/results/'
      path: '/'
      fullPath: '/simops/$studyId/results/'
      preLoaderRoute: typeof AppSimopsStudyIdResultsIndexRouteImport
      parentRoute: typeof AppSimopsStudyIdResultsRoute
    }
    '/_app/simops/$studyId/results/compare': {
      id: '/_app/simops/$studyId/results/compare'
      path: '/compare'
      fullPath: '/simops/$studyId/results/compare'
      preLoaderRoute: typeof AppSimopsStudyIdResultsCompareRouteImport
      parentRoute: typeof AppSimopsStudyIdResultsRoute
    }
    '/_app/simops/$studyId/results/evidence': {
      id: '/_app/simops/$studyId/results/evidence'
      path: '/evidence'
      fullPath: '/simops/$studyId/results/evidence'
      preLoaderRoute: typeof AppSimopsStudyIdResultsEvidenceRouteImport
      parentRoute: typeof AppSimopsStudyIdResultsRoute
    }
    '/_app/simops/$studyId/results/overview': {
      id: '/_app/simops/$studyId/results/overview'
      path: '/overview'
      fullPath: '/simops/$studyId/results/overview'
      preLoaderRoute: typeof AppSimopsStudyIdResultsOverviewRouteImport
      parentRoute: typeof AppSimopsStudyIdResultsRoute
    }
    '/_app/simops/$studyId/results/points': {
      id: '/_app/simops/$studyId/results/points'
      path: '/points'
      fullPath: '/simops/$studyId/results/points'
      preLoaderRoute: typeof AppSimopsStudyIdResultsPointsRouteImport
      parentRoute: typeof AppSimopsStudyIdResultsRoute
    }
    '/_app/simops/$studyId/results/tradeoffs': {
      id: '/_app/simops/$studyId/results/tradeoffs'
      path: '/tradeoffs'
      fullPath: '/simops/$studyId/results/tradeoffs'
      preLoaderRoute: typeof AppSimopsStudyIdResultsTradeoffsRouteImport
      parentRoute: typeof AppSimopsStudyIdResultsRoute
    }
  }
}

interface AppEvaltoolStudyIdResultsRouteChildren {
  AppEvaltoolStudyIdResultsCompareRoute: typeof AppEvaltoolStudyIdResultsCompareRoute
  AppEvaltoolStudyIdResultsEvidenceRoute: typeof AppEvaltoolStudyIdResultsEvidenceRoute
  AppEvaltoolStudyIdResultsOverviewRoute: typeof AppEvaltoolStudyIdResultsOverviewRoute
  AppEvaltoolStudyIdResultsPointsRoute: typeof AppEvaltoolStudyIdResultsPointsRoute
  AppEvaltoolStudyIdResultsTradeoffsRoute: typeof AppEvaltoolStudyIdResultsTradeoffsRoute
  AppEvaltoolStudyIdResultsIndexRoute: typeof AppEvaltoolStudyIdResultsIndexRoute
}

const AppEvaltoolStudyIdResultsRouteChildren: AppEvaltoolStudyIdResultsRouteChildren =
  {
    AppEvaltoolStudyIdResultsCompareRoute:
      AppEvaltoolStudyIdResultsCompareRoute,
    AppEvaltoolStudyIdResultsEvidenceRoute:
      AppEvaltoolStudyIdResultsEvidenceRoute,
    AppEvaltoolStudyIdResultsOverviewRoute:
      AppEvaltoolStudyIdResultsOverviewRoute,
    AppEvaltoolStudyIdResultsPointsRoute: AppEvaltoolStudyIdResultsPointsRoute,
    AppEvaltoolStudyIdResultsTradeoffsRoute:
      AppEvaltoolStudyIdResultsTradeoffsRoute,
    AppEvaltoolStudyIdResultsIndexRoute: AppEvaltoolStudyIdResultsIndexRoute,
  }

const AppEvaltoolStudyIdResultsRouteWithChildren =
  AppEvaltoolStudyIdResultsRoute._addFileChildren(
    AppEvaltoolStudyIdResultsRouteChildren,
  )

interface AppEvaltoolStudyIdRouteChildren {
  AppEvaltoolStudyIdResultsRoute: typeof AppEvaltoolStudyIdResultsRouteWithChildren
  AppEvaltoolStudyIdIndexRoute: typeof AppEvaltoolStudyIdIndexRoute
}

const AppEvaltoolStudyIdRouteChildren: AppEvaltoolStudyIdRouteChildren = {
  AppEvaltoolStudyIdResultsRoute: AppEvaltoolStudyIdResultsRouteWithChildren,
  AppEvaltoolStudyIdIndexRoute: AppEvaltoolStudyIdIndexRoute,
}

const AppEvaltoolStudyIdRouteWithChildren =
  AppEvaltoolStudyIdRoute._addFileChildren(AppEvaltoolStudyIdRouteChildren)

interface AppSimopsStudyIdResultsRouteChildren {
  AppSimopsStudyIdResultsCompareRoute: typeof AppSimopsStudyIdResultsCompareRoute
  AppSimopsStudyIdResultsEvidenceRoute: typeof AppSimopsStudyIdResultsEvidenceRoute
  AppSimopsStudyIdResultsOverviewRoute: typeof AppSimopsStudyIdResultsOverviewRoute
  AppSimopsStudyIdResultsPointsRoute: typeof AppSimopsStudyIdResultsPointsRoute
  AppSimopsStudyIdResultsTradeoffsRoute: typeof AppSimopsStudyIdResultsTradeoffsRoute
  AppSimopsStudyIdResultsIndexRoute: typeof AppSimopsStudyIdResultsIndexRoute
}

const AppSimopsStudyIdResultsRouteChildren: AppSimopsStudyIdResultsRouteChildren =
  {
    AppSimopsStudyIdResultsCompareRoute: AppSimopsStudyIdResultsCompareRoute,
    AppSimopsStudyIdResultsEvidenceRoute: AppSimopsStudyIdResultsEvidenceRoute,
    AppSimopsStudyIdResultsOverviewRoute: AppSimopsStudyIdResultsOverviewRoute,
    AppSimopsStudyIdResultsPointsRoute: AppSimopsStudyIdResultsPointsRoute,
    AppSimopsStudyIdResultsTradeoffsRoute:
      AppSimopsStudyIdResultsTradeoffsRoute,
    AppSimopsStudyIdResultsIndexRoute: AppSimopsStudyIdResultsIndexRoute,
  }

const AppSimopsStudyIdResultsRouteWithChildren =
  AppSimopsStudyIdResultsRoute._addFileChildren(
    AppSimopsStudyIdResultsRouteChildren,
  )

interface AppSimopsStudyIdRouteChildren {
  AppSimopsStudyIdDiagnoseRoute: typeof AppSimopsStudyIdDiagnoseRoute
  AppSimopsStudyIdMeshRoute: typeof AppSimopsStudyIdMeshRoute
  AppSimopsStudyIdResultsRoute: typeof AppSimopsStudyIdResultsRouteWithChildren
  AppSimopsStudyIdSetupRoute: typeof AppSimopsStudyIdSetupRoute
  AppSimopsStudyIdSimulateRoute: typeof AppSimopsStudyIdSimulateRoute
  AppSimopsStudyIdIndexRoute: typeof AppSimopsStudyIdIndexRoute
}

const AppSimopsStudyIdRouteChildren: AppSimopsStudyIdRouteChildren = {
  AppSimopsStudyIdDiagnoseRoute: AppSimopsStudyIdDiagnoseRoute,
  AppSimopsStudyIdMeshRoute: AppSimopsStudyIdMeshRoute,
  AppSimopsStudyIdResultsRoute: AppSimopsStudyIdResultsRouteWithChildren,
  AppSimopsStudyIdSetupRoute: AppSimopsStudyIdSetupRoute,
  AppSimopsStudyIdSimulateRoute: AppSimopsStudyIdSimulateRoute,
  AppSimopsStudyIdIndexRoute: AppSimopsStudyIdIndexRoute,
}

const AppSimopsStudyIdRouteWithChildren =
  AppSimopsStudyIdRoute._addFileChildren(AppSimopsStudyIdRouteChildren)

interface AppRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppCadmorphUuidRoute: typeof AppCadmorphUuidRoute
  AppDiagnosisUuidRoute: typeof AppDiagnosisUuidRoute
  AppEvaltoolStudyIdRoute: typeof AppEvaltoolStudyIdRouteWithChildren
  AppMeshgenUuidRoute: typeof AppMeshgenUuidRoute
  AppSimopsStudyIdRoute: typeof AppSimopsStudyIdRouteWithChildren
  AppSimopsNewRoute: typeof AppSimopsNewRoute
  AppAccountIndexRoute: typeof AppAccountIndexRoute
  AppCadmorphIndexRoute: typeof AppCadmorphIndexRoute
  AppCheckoutIndexRoute: typeof AppCheckoutIndexRoute
  AppDebugIndexRoute: typeof AppDebugIndexRoute
  AppDiagnosisIndexRoute: typeof AppDiagnosisIndexRoute
  AppEvaltoolIndexRoute: typeof AppEvaltoolIndexRoute
  AppMeshgenIndexRoute: typeof AppMeshgenIndexRoute
  AppSimopsIndexRoute: typeof AppSimopsIndexRoute
  AppDebugCacheIndexRoute: typeof AppDebugCacheIndexRoute
  AppDebugThumbnailIndexRoute: typeof AppDebugThumbnailIndexRoute
  AppDebugViewerIndexRoute: typeof AppDebugViewerIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppCadmorphUuidRoute: AppCadmorphUuidRoute,
  AppDiagnosisUuidRoute: AppDiagnosisUuidRoute,
  AppEvaltoolStudyIdRoute: AppEvaltoolStudyIdRouteWithChildren,
  AppMeshgenUuidRoute: AppMeshgenUuidRoute,
  AppSimopsStudyIdRoute: AppSimopsStudyIdRouteWithChildren,
  AppSimopsNewRoute: AppSimopsNewRoute,
  AppAccountIndexRoute: AppAccountIndexRoute,
  AppCadmorphIndexRoute: AppCadmorphIndexRoute,
  AppCheckoutIndexRoute: AppCheckoutIndexRoute,
  AppDebugIndexRoute: AppDebugIndexRoute,
  AppDiagnosisIndexRoute: AppDiagnosisIndexRoute,
  AppEvaltoolIndexRoute: AppEvaltoolIndexRoute,
  AppMeshgenIndexRoute: AppMeshgenIndexRoute,
  AppSimopsIndexRoute: AppSimopsIndexRoute,
  AppDebugCacheIndexRoute: AppDebugCacheIndexRoute,
  AppDebugThumbnailIndexRoute: AppDebugThumbnailIndexRoute,
  AppDebugViewerIndexRoute: AppDebugViewerIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthenticateRoute: AuthenticateRoute,
  LoginRoute: LoginRoute,
  PreferencesRoute: PreferencesRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  OauthAuthorizeRoute: OauthAuthorizeRoute,
  WhatsNewIndexRoute: WhatsNewIndexRoute,
  ShareGeometryUuidRoute: ShareGeometryUuidRoute,
  ShareStudyStudyIdRoute: ShareStudyStudyIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
